import React from 'react';
import gql from 'graphql-tag';
import {
  CreditCardWalletRowFields,
} from '../schemas/rql';
import CreditCardWalletRowSummary, { CreditCardWalletRowSummaryFragment } from './credit_card_wallet_row_summary';

type CreditCard = CreditCardWalletRowFields.CreditCards;

interface Props {
  creditCard: CreditCard;
}

export default function CreditCardWalletRow(props: Props) {
  const { creditCard } = props;

  return (
    <CreditCardWalletRowSummary creditCard={creditCard} />
  );
}

export const CreditCardWalletRowFragment = gql`
  fragment CreditCardWalletRowFields on rql_Me {
    uuid
    creditCards {
      id
    }
    ...CreditCardWalletRowSummaryFields
  }
  ${CreditCardWalletRowSummaryFragment}
`;
